/* eslint-disable custom/no-dynamic-i18n-key -- Shared Trans wrapper forwards caller-supplied namespace:key literals to react-i18next; static extraction uses data-translate-key on the outer span. */
import { Trans as TransI18n, TransProps as TransPropsI18n } from "react-i18next";

import { cn } from "@/utils";

interface ITransProps extends Omit<TransPropsI18n<string>, "ns"> {
  i18nKey: string;
}

const Trans = ({ i18nKey, className, style, ...props }: ITransProps) => {
  return (
    <span data-translate-key={i18nKey} className={cn("font-[inherit]", className)} style={style}>
      <TransI18n i18nKey={i18nKey} {...props} />
    </span>
  );
};

export default Trans;
